define('avatar-binder',['require','knockout'],function (require) {
    var ko = require('knockout');

    function extendBinder(binder, name, update) { // TODO support init
        ko.bindingHandlers[name] = {
            update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var params = ko.utils.unwrapObservable(valueAccessor());
                var wrappedAccessor = function () {
                    return update(params);
                };
                ko.bindingHandlers[binder].update(element, wrappedAccessor, allBindingsAccessor, viewModel,
                    bindingContext);
            }
        };
    }

    // CDN Avatar URL
    extendBinder('attr', 'cdnUrl', function (params) {
        // TODO configure these URLs in main, not here!
        var CDN = 'd1ho4l1jd34cw6.cloudfront.net';
        var url = '//cdn.gotomeet.at/images/web-portal/gotomeet/avatar.png'; // TODO configure CDN

        if (params) {
            url = params;
            if (params.indexOf('www.filepicker.io') !== -1) {
                // TODO accept size params in binder:
                url = params.replace('www.filepicker.io', CDN) + '/convert?w=300&h=300&fit=crop&align=faces';
            }
        }

        return {
            src: url
        };
    });
});

